export default "__VITE_PUBLIC_ASSET__2e1aed31__"